define("jquery/jquery.cookie",["jquery","js-cookie/cookie-wrapper"],function(){});
